<template>
  <div id="student" class="okr">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <router-link to="/okrvoorzitter">
            <span class="icon is-small">
              <i class="fas fa-home"></i>
            </span>
            <span>Mijn Klas</span>
          </router-link>
        </li>
        <li class="is-active">
          <a href="#" aria-current="page">
            <span class="icon is-small">
              <i class="fas fa-user"></i>
            </span>
            <span>{{student.tbl_student.firstname}} {{student.tbl_student.surname}}</span>
          </a>
        </li>
      </ul>
    </nav>

    <p class="field">
      <a class="button is-light" @click="previous()" disabled>
        <b-icon icon="chevron-left"></b-icon>
      </a>
      <a class="button is-light" @click="backClick(tbl_conf_class.testgroup)">
        <b-icon icon="home"></b-icon>
      </a>
      <a class="button is-light" @click="next()" disabled>
        <b-icon icon="chevron-right"></b-icon>
      </a>
    </p>
    <form id="form" name="student">
      <section class="columns">
        <div class="column is-one-third">
          <div class="card">
            <header class="card-header">
              <p class="card-header-title">
                Personalia
              </p>
            </header>
            <div class="card-content">
              <section>
                <b-field label="Schoolnr:">
                  <b-input expanded size="is-normal" v-model="student.tbl_school.schoolnumber" readonly></b-input>
                </b-field>
                <b-field label="Testgroup:">
                  <b-input expanded size="is-normal" v-model="student.tbl_conf_class.testgroup" readonly></b-input>
                </b-field>
                <b-field label="Leerlingnr:">
                  <b-input readonly expanded size="is-normal" v-model="student.student_number" @blur="updateNR()"></b-input>
                </b-field>
                <b-field label="Groep:">
                  <b-input expanded size="is-normal" v-model="student.tbl_conf_class.tbl_grade.grade" readonly></b-input>
                </b-field>
                <b-field label="Achternaam:">
                  <b-input size="is-normal" v-model="student.tbl_student.surname" readonly></b-input>
                </b-field>
                <b-field label="Voorvoegsel:">
                  <b-input v-if="user.tbl_sys_user.tbl_school.tbl_conf_schoolboard.abbriviation =='RKCSB'" size="small" v-model="student.tbl_student.preposition" @blur="updatePersonalia()"></b-input>
                  <b-input v-else size="small" v-model="student.tbl_student.preposition" readonly></b-input>
                </b-field>
                <b-field label="Voornaam:">
                  <b-input size="is-normal" v-model="student.tbl_student.firstname" readonly></b-input>
                </b-field>
                <b-field label="IDNR:">
                  <b-input size="is-normal" v-model="student.tbl_student.governement_id" @blur="updatePersonalia()"></b-input>
                </b-field>
                <b-field label="Geboortedatum:">
                  <b-datepicker :readonly="false" icon="calendar" placeholder="Geboorte datum.." v-model="student.tbl_student.birthdate" @input="updatePersonalia()"></b-datepicker>
                </b-field>
                <b-field label="Geboorteplaats:">
                  <b-select v-model="student.tbl_student.birthplace_id" filterable placeholder="Kies een geboorteplaats ..." @input="updatePersonalia()">
                    <option v-for="item in birthplaces" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Sexe:">
                  <b-select v-model="student.tbl_student.gender_id" filterable placeholder="Kies een geslacht ..." @input="updatePersonalia()">
                    <option v-for="item in genders" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Moedertaal:">
                  <b-select v-model="student.tbl_student.native_language_id" filterable placeholder="Kies een moedertaal ..." @input="updatePersonalia()">
                    <option v-for="item in languages" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Adres:">
                  <b-input size="is-normal" v-model="student.tbl_student.address" @blur="updatePersonalia()"></b-input>
                </b-field>
                <b-field label="Woonbuurt:">
                  <b-input size="is-normal" v-model="student.tbl_student.neighborhood" @blur="updatePersonalia()"></b-input>
                </b-field>
                <b-field label="Telefoon:">
                  <b-input size="is-normal" v-model="student.tbl_student.telephone" @blur="updatePersonalia()"></b-input>
                </b-field>
                <b-field label="Email:" prop="tbl_student.email" :rules="[{ type: 'email', message: 'Please input correct email address', trigger: 'blur,input'} ]">
                  <b-input size="is-normal" v-model="student.tbl_student.email" @blur="updatePersonalia()"></b-input>
                </b-field>
                <b-field label="Godsdienst:">
                  <b-select v-model="student.tbl_student.denomination_id" filterable placeholder="Godsdienst ..." @input="updatePersonalia()">
                    <option v-for="item in religions" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Nationaliteit:">
                  <b-select v-model="student.tbl_student.nationality_id" filterable placeholder="Nationaliteit ..." @input="updatePersonalia()">
                    <option v-for="item in nationality" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Ingeschreven vanaf:">
                  <b-datepicker :readonly="false" icon="calendar" placeholder="Datum ingeschreven" v-model="student.registration_date" @input="updatePersonalia()"></b-datepicker>
                </b-field>
                <b-field label="Afkomstig van:">
                  <b-select v-model="student.last_school" filterable placeholder="Kies vorige school ..." @input="updatePersonalia()">
                    <option v-for="item in schools" :label="item.name" :key="item.id" :value="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Leerstoornis:">
                  <!-- <div class="block"> -->
                  <b-checkbox v-model="disabilities_selected" v-for="item in disabilities" :native-value="item.id" :key="item.id" @input="update_learning_disorder()">{{item.learning_disability}}</b-checkbox>
                  <!-- </div> -->
                </b-field>
                <b-field label="Slechtziend:">
                  <b-checkbox v-model="student.tbl_student.visually_impaired" @input="updatePersonalia()"></b-checkbox>
                </b-field>
                <b-field class="okritem " label="In welke taal maakt leerling rekenen? ">
                  <b-select size="small " v-model="student.language_id" filterable placeholder="Kies taal ... " @input="updatePersonalia() ">
                    <option v-for="item in mathlanguages " :label="item.language" :key="item.id" :value="item.id ">
                    </option>
                  </b-select>
                </b-field>
              </section>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="columns">
            <div class="column">
              <verzuimtelaat :studentid="student.student_id"></verzuimtelaat>
            </div>
            <div class="column">
              <interesse :studentid="student.student_id"></interesse>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <andere :studentid="student.student_id"></andere>
            </div>
            <div class="column">
              <gedrag :studentid="student.student_id"></gedrag>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <leerprestaties :studentid="student.student_id"></leerprestaties>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <leerdeficientie :studentid="student.student_id"></leerdeficientie>
            </div>
          </div>
        </div>
      </section>
      <section class="columns">
        <div class="column">
          <sociaalemo :studentid="student.student_id"></sociaalemo>
        </div>
        <div class="column">
          <omgangleerkracht :studentid="student.student_id"></omgangleerkracht>
        </div>
        <div class="column">
          <contactouders :studentid="student.student_id"></contactouders>
        </div>
      </section>
      <section class="columns">
        <div class="column is-7">
          <subjectmarks :studentid="student.student_id"></subjectmarks>
        </div>
        <div class="column">
          <div class="card">
            <header class="card-header">
              <p class="card-header-title">
                Werkhouding
              </p>
            </header>
            <div class="card-content">
              <section>
                <h4 class="subtitle">Concentratie</h4>
                <concentratie :studentid="student.student_id"></concentratie>
                <br>
                <h4 class="subtitle">Motivatie</h4>
                <motivatie :studentid="student.student_id"></motivatie>
                <br>
                <h4 class="subtitle">Werktempo</h4>
                <werktempo :studentid="student.student_id"></werktempo>
                <br>
                <h4 class="subtitle">Doorzettingsvermogen</h4>
                <doorzettingsvermogen :studentid="student.student_id"></doorzettingsvermogen>
                <br>
                <h4 class="subtitle">Nauwkeurigheid</h4>
                <nauwkeurigheid :studentid="student.student_id"></nauwkeurigheid>
                <br>
                <h4 class="subtitle">Zelfstandigheid</h4>
                <zelfstandigheid :studentid="student.student_id"></zelfstandigheid>
                <br>
                <h4 class="subtitle">Voorkeur vervolgonderwijs</h4>
                <b-field label="Advies directeur vervolgonderwijs:" label-width="350px">
                  <b-select v-model="further_education.director_advice" filterable placeholder="Select" @input="update_vervolgonderwijs()">
                    <option label="HAVO" value="HAVO"> </option>
                    <option label="VSBO" value="VSBO"> </option>
                    <option label="AGO" value="AGO"> </option>
                  </b-select>
                </b-field>

                <b-field label="Motivering van advies door directeur" label-width="350px">
                  <b-input type="textarea" size="small" style="width:400px;" v-model="further_education.justification" @blur="update_vervolgonderwijs()"></b-input>
                </b-field>

                <h4>Schoolkeuze vervolgonderwijs</h4>
                <b-field class="okritem" label="Schoolkeuze Havo 1 :" label-width="175px">
                  <b-select style="width:300px;" size="small" v-model="further_education.sys_havo_id_1" filterable @input="update_vervolgonderwijs()">
                    <option value="0">Geen Keuze</option>
                    <option v-for="item in havo" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field class="okritem" label="Schoolkeuze Havo 2 :" label-width="175px">
                  <b-select style="width:300px;" size="small" v-model="further_education.sys_havo_id_2" filterable @input="update_vervolgonderwijs()">
                    <option value="0">Geen Keuze</option>
                    <option v-for="item in havo" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field class="okritem" label="Schoolkeuze Havo 3 :" label-width="175px">
                  <b-select style="width:300px;" size="small" v-model="further_education.sys_havo_id_3" filterable @input="update_vervolgonderwijs()">
                    <option value="0">Geen Keuze</option>
                    <option v-for="item in havo" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field class="okritem" label="Schoolkeuze VSBO 1 :" label-width="175px">
                  <b-select style="width:300px;" size="small" v-model="further_education.sys_vsbo_id_1" filterable @input="update_vervolgonderwijs()">
                    <option value="0">Geen Keuze</option>
                    <option v-for=" item in vsbo" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field class="okritem" label="Schoolkeuze VSBO 2 :" label-width="175px">
                  <b-select style="width:300px;" size="small" v-model="further_education.sys_vsbo_id_2" filterable @input="update_vervolgonderwijs()">
                    <option value="0">Geen Keuze</option>
                    <option v-for="item in vsbo" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
                <b-field class="okritem" label="Schoolkeuze VSBO 3 :" label-width="175px">
                  <b-select style="width:300px;" size="small" v-model="further_education.sys_vsbo_id_3" filterable @input="update_vervolgonderwijs()">
                    <option value="0">Geen Keuze</option>
                    <option v-for="item in vsbo" :label="item.name" :value="item.id" :key="item.id">
                    </option>
                  </b-select>
                </b-field>
              </section>
            </div>
          </div>
        </div>

      </section>
      <section class="columns">
        <div class="column">
          <div class="card">
            <header class="card-header">
              <p class="card-header-title">
                Ouders
              </p>
            </header>
            <div class="card-content">
              <section>

                <b-field class="okritem" label="" label-width="500px ">
                  <b-checkbox v-model="further_education.objection_advice" @input="update_vervolgonderwijs()"> Ouders waren niet tevreden met advies en hebben gesprek aangevraagd </b-checkbox>
                </b-field>
                <b-field class="okritem" label="" label-width="500px ">
                  <b-checkbox v-model="further_education.appeal_result" @input="update_vervolgonderwijs()">Ouders gaan in beroep tegen de uitslag</b-checkbox>
                </b-field>

              </section>
            </div>
          </div>
        </div>
      </section>
      <section class="columns">
        <div class="column">
          <div class="card">
            <header class="card-header">
              <p class="card-header-title">
                Bijzonderheden
              </p>
            </header>
            <div class="card-content">
              <section>
                <b-input type="textarea" :rows="5" placeholder="Please input" v-model="further_education.particularies" @blur="update_vervolgonderwijs">
                </b-input>
              </section>
            </div>
          </div>
        </div>
      </section>
      <b-loading :active.sync="loading"></b-loading>
    </form>


  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment";
import Cookies from "js-cookie";
//import Icon from "vue-awesome/components/Icon.vue";
import Markitems from "../components/Markitems";
import Verzuimtelaat from "../components/okr/VerzuimTelaat";
import Interesse from "../components/okr/Interesse";
import Andere from "../components/okr/Andere";
import Gedrag from "../components/okr/Gedrag";
import Leerprestaties from "../components/okr/Leerprestaties";
import Sociaalemo from "../components/okr/Sociaalemo";
import Omgangleerkracht from "../components/okr/Omgangleerkracht";
import Contactouders from "../components/okr/Contactouders";
import Leerdeficientie from "../components/okr/Leerdeficientie";
import Concentratie from "../components/okr/Concentratie";
import Motivatie from "../components/okr/Motivatie";
import Werktempo from "../components/okr/Werktempo";
import Doorzettingsvermogen from "../components/okr/Doorzettingsvermogen";
import Zelfstandigheid from "../components/okr/Zelfstandigheid";
import Nauwkeurigheid from "../components/okr/Nauwkeurigheid";
 import Vervolgonderwijs from '../components/okr/Vervolgonderwijs'
import Ouders from '../components/okr/Ouders'
import Subjectmarks from "../components/okr/Subjectmarks";
import { API_ROOT } from "../config";
var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 60000
});

export default {
  name: "student",
  components: {
    Markitems,
    Verzuimtelaat,
    Interesse,
    Andere,
    Gedrag,
    Leerprestaties,
    Sociaalemo,
    Omgangleerkracht,
    Contactouders,
    Leerdeficientie,
    Concentratie,
    Motivatie,
    Werktempo,
    Doorzettingsvermogen,
    Nauwkeurigheid,
    Vervolgonderwijs,
    Zelfstandigheid,
    Ouders,
    Subjectmarks
  },
  data: function() {
    return {
      //main_loading: true,
      access: Cookies.get("access"),
      user: Cookies.getJSON("user"),
      isRK: false,
      birthplaces: [],
      genders: [],
      languages: [],
      mathlanguages: [],
      religions: [],
      schools: [],
      nationality: [],
      disabilities: [
        {
          id: "",
          learning_disability: ""
        }
      ],
      disabilities_selected: ["", "", "", "", "", "", ""],
      further_education: {
        id: 0,
        student_id: 0,
        director_advice: "",
        justification: "",
        sys_havo_id_1: 0,
        sys_havo_id_2: 0,
        sys_havo_id_3: 0,
        sys_vsbo_id_1: 0,
        sys_vsbo_id_2: 0,
        sys_vsbo_id_3: 0,
        objection_advice: 0,
        appeal_result: 0,
        particularies: "",
        updatedBy: ""
      },
      havo: [],
      havo1_selected: [],
      havo2_selected: [],
      havo3_selected: [],
      vsbo: [],
      vsbo1_selected: [],
      vsbo2_selected: [],
      vsbo3_selected: [],
      bijzonderheden: "",
      marksData: [],
      student: {
        id: "",
        schoolyear_id: "",
        school_id: "",
        class_id: "",
        tbl_conf_class: {
          id: "",
          school_id: "",
          grade_id: "",
          tbl_grade: {
            id: "",
            grade: "",
            description: ""
          },
          name: "",
          testgroup: ""
        },
        student_id: "",
        language_id: "",
        student_number: "",
        registration_date: "",
        last_school: "",
        tbl_student: {
          id: "",
          governement_id: "",
          surname: "",
          firstname: "",
          preposition: "",
          nickname: "",
          gender_id: "",
          birthdate: "",
          birthplace_id: "",
          denomination_id: "",
          native_language_id: "",
          address: "",
          neighborhood: "",
          telephone: "",
          nationality_id: "",
          telephone_owner: "",
          email: "",
          visually_impaired: false,
          tbl_studen_marks: [],
          tbl_student_learning_disabilties: [],
          tbl_student_miscellaneous_marks: [],
          tbl_further_education: {
            id: 0,
            student_id: 0,
            director_advice: "",
            justification: "",
            sys_havo_id_1: 0,
            sys_havo_id_2: 0,
            sys_havo_id_3: 0,
            sys_vsbo_id_1: 0,
            sys_vsbo_id_2: 0,
            sys_vsbo_id_3: 0,
            objection_advice: false,
            appeal_result: false,
            particularies: ""
          }
        },
        tbl_school: {
          id: "0",
          schoolboard_id: "",
          name: " ",
          address: "",
          telephone: "",
          fax: "",
          email: "",
          webpage: "",
          d_name: "",
          d_address: "",
          d_telephone: "",
          d_fax: "",
          d_email: "",
          w_name: "",
          w_address: "",
          w_telehpone: "",
          w_fax: "",
          w_email: "",
          schoolnumber: "",
          schooltype_id: "",
          createdAt: "",
          updatedAt: ""
        }
      }
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    //this.fetch()
    console.log("Fetching Data");

    console.log(this.user.data);
    if (this.access == 0) {
      this.$router.push({
        path: "/"
      });
    }

    this.fetch_data();
    this.fetch_student();
    //this.fetch_marks();

    console.log("Student Form");
    console.log(this.student_form);
  },
  watch: {
    student(val) {
      console.log("input detected in student");
      console.log(val);
    }
  },
  computed: {
    loading() {
      var load_object = this.$store.getters.getLoading;
      var keys = _.keys(load_object);
      var load = true;

      console.log("Watch");
      console.log(keys);
      for (var i = 0; i < keys.length; i++) {
        console.log(load_object[keys[i]]);
        if (load_object[keys[i]]) {
          i = keys.length;
        } else {
          load = false;
        }
      }

      return load;
    },
    // user() {
    //   return this.$store.getters.getUser;
    // },
    // firstlogin() {
    //   return this.$store.getters.getFirstlogin;
    // },
    tbl_student() {
      console.log(this.student);
      if (this.student.id != "") {
        this.fetch_marks(this.student.student_id);

        return this.student.tbl_student;
      } else {
        return {
          id: "",
          governement_id: "",
          surname: "",
          firstname: "",
          preposition: "",
          nickname: "",
          gender_id: "",
          birthdate: "",
          birthplace_id: "",
          denomination_id: "",
          native_language_id: "",
          address: "",
          neighborhood: "",
          telephone: "",
          nationality_id: "",
          telephone_owner: "",
          email: "",
          visually_impaired: ""
        };
      }
    },
    tbl_conf_class() {
      if (!_.isUndefined(this.student)) {
        return this.student.tbl_conf_class;
      } else {
        return {
          id: "",
          school_id: "",
          grade_id: "",
          tbl_grade: {
            id: "",
            grade: "",
            description: ""
          },
          name: "",
          testgroup: ""
        };
      }
    },
    tbl_school() {
      if (!_.isUndefined(this.student)) {
        return this.student.tbl_school;
      } else {
        return {
          id: "0",
          schoolboard_id: "",
          name: " ",
          address: "",
          telephone: "",
          fax: "",
          email: "",
          webpage: "",
          d_name: "",
          d_address: "",
          d_telephone: "",
          d_fax: "",
          d_email: "",
          w_name: "",
          w_address: "",
          w_telehpone: "",
          w_fax: "",
          w_email: "",
          schoolnumber: "",
          schooltype_id: "",
          createdAt: "",
          updatedAt: ""
        };
      }
    }
  },
  methods: {
    fetch_student() {
      var self = this;
      instance
        .get("/student-class/" + this.$route.params.id)
        .then(function(response) {
          var stud = response.data.data;
          _.merge(self.student, response.data.data);
          console.log("Student object fetched...");
          self.tbl_student.visually_impaired =
            self.student.tbl_student.visually_impaired == 1 ? true : false;

          self.student.tbl_student.birthdate = _.isEmpty(
            self.student.tbl_student.birthdate
          )
            ? null
            : moment(self.student.tbl_student.birthdate).toDate();

          self.student.registration_date = _.isEmpty(
            self.student.registration_date
          )
            ? null
            : moment(self.student.registration_date).toDate();

          self.$store.dispatch("load", {
            name: "personalia",
            value: false
          });
        });
    },
    previous() {
      instance
        .post("/student/update", this.tbl_student)
        .then(function(response) {
          //console.log(response.data.data);
        });
    },
    next() {
      // SELECT
      //     *
      // FROM
      //     tbl_student_class
      // WHERE
      //     school_id = schoolid and class_id = classid AND student_number < studentnumber
      // ORDER BY student_number desc
      // LIMIT 1;

      instance
        .post("/student/update", this.tbl_student)
        .then(function(response) {
          //console.log(response.data.data);
        });
    },
    updatePersonalia() {
      instance
        .post("/student/update", this.tbl_student)
        .then(function(response) {
          //console.log(response.data.data);
        });
      instance
        .post("/student-class/update", this.student)
        .then(function(response) {
          //console.log(response.data.data);
        });
    },
    updateNR() {
      instance
        .post("/student/studentnumber", {
          id: this.student.student_id,
          student_number: this.student.student_number
        })
        .then(function(response) {
          console.log("saved");
        });
    },
    update_vervolgonderwijs() {
      //first delete all disabilities the nsave new list
      console.log("UPDATE VERVOLGONDERWIJS!!!!!!");
      console.log(this.further_education);

      var self = this;

      this.further_education.student_id = this.student.student_id;
      //this.further_education.updated = this.user.tbl_sys_user.username;
      instance
        .post("/further-education-update", this.further_education)
        .then(function(response) {
          //console.log(response.data.data);
          instance
            .get("/further-education/" + self.student.student_id)
            .then(function(response) {
              if (response.data.data.length > 0) {
                console.log("Further Education");
                console.log(response.data.data[0]);

                _.merge(self.further_education, response.data.data[0]);
                self.further_education.objection_advice =
                  self.further_education.objection_advice == 1 ? true : false;
                self.further_education.appeal_result =
                  self.further_education.appeal_result == 1 ? true : false;
              }
            });
        });
    },
    update_marks(obj) {
      //first delete all disabilities the nsave new list
      console.log("Update marks");
      console.log(obj);
      instance
        .post("/student-misc-mark/update", {
          student_id: obj.id,
          sys_miscellaneous_id: obj.sys_miscellaneous_id,
          mark: obj.mark
        })
        .then(function(response) {
          //console.log(response.data.data);
        });
    },

    update_learning_disorder() {
      //first delete all disabilities the nsave new list

      instance
        .post("/student-learning-disability/delete/", {
          id: this.student.student_id
        })
        .then(function(response) {
          //console.log(response.data.data);
        });

      console.log("UPDATETING LEARNING DISABILITIES!!!!");

      for (var i = 0; i < this.disabilities_selected.length; i++) {
        if (this.disabilities_selected[i] > 0) {
          instance
            .post("/student-learning-disability", {
              learning_disability_id: this.disabilities_selected[i],
              student_id: this.student.student_id
            })
            .then(function(response) {
              //console.log(response.data.data);
            });
        }
      }
    },
    fetch() {
      for (var i = 1; i < 18; i++) {
        this.$store.dispatch("marks", i);
      }
    },
    fetch_marks(studentid) {
      this.params = this.$route.params;

      var self = this;

      instance.get("/further-education/" + studentid).then(function(response) {
        if (response.data.data.length > 0) {
          console.log("Further Education");
          console.log(response.data.data[0]);

          _.merge(self.further_education, response.data.data[0]);
          self.further_education.objection_advice =
            self.further_education.objection_advice == 1 ? true : false;
          self.further_education.appeal_result =
            self.further_education.appeal_result == 1 ? true : false;
        }
      });

      console.log("AFTER LOADING LEARNING DISABILITY! 11111111111111111111");
      console.log(studentid);
      instance
        .get("/student-learning-disability-student/" + studentid)
        .then(function(response) {
          var selected = [];
          console.log("Fetch mongool");
          console.log(studentid);
          console.log(response.data.msg);
          console.log(response.data.data);
          for (var i = 0; i < response.data.data.length; i++) {
            self.$set(
              self.disabilities_selected,
              i,
              response.data.data[i].learning_disability_id
            );
          }

          self.$store.dispatch("load", {
            name: "vervolgonderwijs",
            value: false
          });
        });

      var arr_misc_marks = [];
      _.merge(
        arr_misc_marks,
        this.student.tbl_student.tbl_student_miscellaneous_marks
      );

      var misc_marks = _.filter(arr_misc_marks, function(o) {
        return o.tbl_sys_miscellaneou.sys_miscellaneous_type_id == 1;
      });

      self.$store.dispatch("verzuim", misc_marks);
    },
    fetch_data() {
      this.params = this.$route.params;
      //console.log(this.params);

      var self = this;
      //TODO:move lists to store later

      instance.get("/birthplace").then(function(response) {
        _.merge(self.birthplaces, response.data.data);
      });

      instance.get("/native-langauge").then(function(response) {
        _.merge(self.languages, response.data.data);
      });

      instance.get("/math-language").then(function(response) {
        _.merge(self.mathlanguages, response.data.data);
      });

      instance.get("/denomination").then(function(response) {
        _.merge(self.religions, response.data.data);
      });

      instance.get("/school").then(function(response) {
        _.merge(self.schools, response.data.data);
      });

      instance.get("/gender").then(function(response) {
        _.merge(self.genders, response.data.data);
      });

      instance.get("/nationality").then(function(response) {
        _.merge(self.nationality, response.data.data);
      });

      instance.get("/school/type/4").then(function(response) {
        _.merge(self.havo, response.data.data);
      });

      instance.get("/school/type/3").then(function(response) {
        _.merge(self.vsbo, response.data.data);
      });

      instance.get("/learning-disability/").then(function(response) {
        _.merge(self.disabilities, response.data.data);
      });
    },
    format(date, format) {
      if (!date) {
        return "N/A";
      }
      return moment(date).format(format);
    },
    backClick(testgroup) {
      console.log(testgroup);

      this.$router.push({
        path: "/okrvoorzitter",
        params: {
          testgrp: testgroup
        }
      });
    }
  }
};
</script>
<style scoped>

</style>
